<template>
  <div>
    <QuestionEditor :payload="{ question: question, resource_type: 'Position', resource_id: payload.resource_id }" />
    <br>
    <GhanaFlag :payload="payload.resources.position" :additional_data="{ resource_type: 'Position' }" />
  </div>
</template>

<script>
import GhanaFlag from '@/components/GhanaFlag'
import QuestionEditor from '@/components/QuestionEditor.vue'

export default {
  name: 'PositionGhanaFlag',
  components: {
    GhanaFlag,
    QuestionEditor
  },
  props: ['payload'],
  data () {
    return {
      question: null
    }
  },
  created () {
    this.$network_utils.getResourceQuestions({
      current_type: 'Position',
      current_resource_id: this.payload.resource_id,
      designators: 'urgency'
    }).then(response => {
      this.question = response[0]
    })
  }
}
</script>
